import config from '../config';

export const IDENTITY_CONFIG = {
  authority: 'http://uq.unq.se/IdentitySrv/connect/authorize',
  client_id: 'mvc',
  redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI || config.oidc.redirectUri,
  post_logout_redirect_uri: process.env.REACT_APP_OIDC_LOGOUT_URL || config.oidc.logoutUrl,
  response_type: 'token',
  scope: process.env.REACT_APP_OIDC_SCOPE || config.oidc.scope,
  silent_redirect_uri: process.env.REACT_APP_OIDC_SILENT_RENEW_URI || config.oidc.silentRenewUri,
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTime: 4,
  silentRequestTimeout:10000,
  login: process.env.REACT_APP_OIDC_LOGIN_URL || config.oidc.loginUrl,
  filterProtocolClaims: true,
  loadUserInfo: false
};

export const METADATA_OIDC = {
  issuer: 'https://identityserver',
  jwks_uri: "http://uq.unq.se/IdentitySrv/.well-known/openid-configuration/jwks",
  authorization_endpoint: "http://uq.unq.se/IdentitySrv/connect/authorize",
  token_endpoint: "http://uq.unq.se/IdentitySrv/connect/token",
  userinfo_endpoint: "http://uq.unq.se/IdentitySrv/connect/userinfo",
  end_session_endpoint: "http://uq.unq.se/IdentitySrv/connect/endsession",
  check_session_iframe: "http://uq.unq.se/IdentitySrv/connect/checksession",
  revocation_endpoint: "http://uq.unq.se/IdentitySrv/connect/revocation",
  introspection_endpoint: "http://uq.unq.se/IdentitySrv/connect/introspect"
};